import { result, find } from 'lodash';
import countries from '../../../common/constants/ISOCountriesCodes';

export const getCountryByCode = (code) => result(find(countries, { 'alpha-2': code }), 'name', '');

export const getCountries = () => countries.map((country) => ({ value: { name: country.name, code: country['alpha-2'] }, label: country.name }));
